import { render, staticRenderFns } from "./RecoverPin.vue?vue&type=template&id=b7744d00"
import script from "./RecoverPin.vue?vue&type=script&lang=js"
export * from "./RecoverPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports